import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import auth from '../services/authService';
import config from '../config.js';

import { Button } from '@rmwc/button';

// BT6URH9MCA349B9W_PRD_FAI -> FAI (the full name is still what gets sent to SyteLine)
function shortConfigName(configuration) {
    return configuration.split('_').pop();
}

class Login extends Component {
    constructor(props) {
        super(props);

        this.availableConfigurations = config.configurations;

        // An on-prem value (FAI/FAM) may still be saved in the browser - only reuse it if it's a cloud config
        let prevConfig = auth.getSytelineConfig();
        if (!this.availableConfigurations.includes(prevConfig)) {
            prevConfig = this.availableConfigurations[0];
        }

        this.state = {
            configuration: prevConfig,
            signOutReason: auth.takeSignOutReason(),
        }
    }

    login = () => {
        // Leaves the app for the Infor sign-in page; comes back on /callback
        auth.login(this.state.configuration);
    }

    render() {
        const { from } = (this.props.location && this.props.location.state) || { from: { pathname: '/' } }

        if (auth.isLoggedIn()) {
            return <Redirect to={from} />
        }

        return (
            <div className="login-page">
                <h2>PM Dashboard Login</h2>
                <div className="login-form-section">
                    <form onSubmit={(evt) => { evt.preventDefault(); this.login(); }}>
                        <label className="login-config-label" htmlFor="configuration">Configuration</label>
                        <select id="configuration" className="login-config-select login-textfield-spacing"
                            value={this.state.configuration}
                            onChange={(evt) => this.setState({configuration: evt.target.value})}>
                            {this.availableConfigurations.map((c) =>
                                <option key={c} value={c}>{shortConfigName(c)}</option>)}
                        </select>
                    </form>
                    <Button className="login-textfield-spacing" raised onClick={this.login}>Sign in with Infor</Button>
                    {this.state.signOutReason &&
                        <div className="login-result" style={{ maxWidth: '600px', wordBreak: 'break-word' }}>{this.state.signOutReason}</div>}
                </div>
            </div>
        )
    }
}

export default Login;
